import React from 'react';
import { Pressable, View } from 'react-native';
import { Icon, type IconName } from './Icon';
import { Text } from './Text';
import { useTheme } from './theme';

export function ListItem({
  title,
  subtitle,
  icon,
  left,
  right,
  onPress,
  chevron,
  divider = true,
  highlight,
  testID,
}: {
  title: string;
  subtitle?: string | null;
  icon?: IconName;
  left?: React.ReactNode;
  right?: React.ReactNode;
  onPress?: () => void;
  chevron?: boolean;
  divider?: boolean;
  highlight?: boolean;
  testID?: string;
}) {
  const { colors } = useTheme();
  return (
    <Pressable
      testID={testID}
      disabled={!onPress}
      onPress={onPress}
      accessibilityRole={onPress ? 'button' : undefined}
      style={({ pressed }) => ({ flexDirection: 'row', alignItems: 'center', gap: 12, paddingHorizontal: 16, paddingVertical: 12, backgroundColor: pressed ? colors.hover : highlight ? colors.primarySoft : 'transparent', borderBottomWidth: divider ? 1 : 0, borderBottomColor: colors.border })}
    >
      {left ?? (icon ? (
        <View style={{ width: 32, height: 32, borderRadius: 8, backgroundColor: colors.surface2, alignItems: 'center', justifyContent: 'center' }}>
          <Icon name={icon} size={16} color={colors.muted} />
        </View>
      ) : null)}
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text weight="medium" numberOfLines={2}>
          {title}
        </Text>
        {!!subtitle && (
          <Text variant="small" numberOfLines={2}>
            {subtitle}
          </Text>
        )}
      </View>
      {right}
      {chevron && <Icon name="chevronRight" size={16} color={colors.faint} />}
    </Pressable>
  );
}

/** Label/value rows (profile details, summaries). */
export function DescList({ items }: { items: [string, React.ReactNode][] }) {
  const { colors } = useTheme();
  return (
    <View>
      {items.map(([k, v], i) => (
        <View key={k} style={{ flexDirection: 'row', gap: 12, paddingVertical: 8, borderBottomWidth: i < items.length - 1 ? 1 : 0, borderBottomColor: colors.border }}>
          <Text variant="muted" style={{ width: 150 }}>
            {k}
          </Text>
          <View style={{ flex: 1 }}>{typeof v === 'string' || typeof v === 'number' || v == null ? <Text>{v == null || v === '' ? '—' : String(v)}</Text> : v}</View>
        </View>
      ))}
    </View>
  );
}
